import React from "react";

export const EquipmentsContext = React.createContext({});